import { firebaseAction } from 'vuexfire';
import db from '@/db';

const state = {
  users: [],
};

const getters = {
  // eslint-disable-next-line no-shadow
  usersById(state) {
    return state.users.reduce((byId, user) => {
      // eslint-disable-next-line no-param-reassign
      byId[user.id] = user;
      return byId;
    }, {});
  },
};

const actions = {
  init: firebaseAction(({ bindFirebaseRef }) => {
    bindFirebaseRef('users', db.collection('users'));
  }),
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
};
